<template>
<transition name="fade-block">
    <div class="song-widget col-xs-12">
        <div v-if="song" class="inner-container" :class="{'liked' : isLiked, 'disliked' : isDisliked, 'playing': activeSongId == song.id}">
            <div @click="play" class="thumbnail">
                <div :data-img="getSongImage" class="lazzyLoad"></div>
            </div>
            <div class="artist" @click="openRoute"><span class="index">{{index}}.</span>{{ song.artist }}</div>
            <div class="name" @click="openRoute">{{ song.name }}</div>
            <div class="info" @click="openRoute" v-html="views"></div>

            <div class="button button-center more" @click="showOptions = true">
                <i class="iconify" data-icon="zmdi:more"></i>
            </div>
        </div>

        <div class="move-to-root">
            <transition name="page-overlay">
                <div class="page-overlay dark song-options" :id="oid" v-show="showOptions">
                    <div class="container">
                        <div class="row">
                            <div class="col-xs-12">
                                <ul v-if="!isOwner">
                                    <li class="button button-white" v-show="!hasDetailedAccess && !requestPending" @click="askDataPermission()">Request Data Access</li>
                                    <li class="button button-white" @click="showPlaylistManager()">Add to Playlist</li>
                                    <li class="button button-white" @click="toggleBlock()">{{ isBlocked ? 'Unblock' : 'Block' }} {{ isArtist ? 'artist' : 'label' }}</li>
                                    <li class="button button-white" @click="toggleFollow()">{{ isFollowed ? 'Unfollow' : 'Follow' }} {{ isArtist ? 'artist' : 'label' }}</li>
                                    <li class="button button-white" @click="toggleLike()">{{ isLiked ? 'Dislike' : 'Like' }}</li>
                                    <li class="button button-white" @click="shareMobile()">Share</li>
                                </ul>

                                <ul v-else>
                                    <!-- <li class="button button-white disabled">Edit</li> -->
                                    <li class="button button-white" @click="showPlaylistManager()">Add to Playlist</li>
                                    <li class="button button-white" @click="toggleRelease()" v-show="!hasNoVideo">{{ !isReleased ? 'Release' : 'Unrelease' }}</li>
                                    <li class="button button-white" @click="togglePublish()" v-show="!hasNoVideo">{{ !isPublished ? 'Publish' : 'Unpublish' }}</li>
                                    <li class="button button-white" @click="shareMobile()">Share</li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-xs-12 text-center m-t-16">
                            <div class="btn btn-round button" @click="showOptions = false">back</div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>        
    </div>
</transition>
</template>

<script>
export default {
    props: ['song', 'layout', 'filterKey', 'filterValue', 'index', 'showData', 'origin', 'privacy'],

    data() {
        return {
            oid: "options_"+ this.song.id +"_"+ Math.random().toString(36).substr(2, 9),
            showOptions: false,
            requestPending: false,
            activeSongId: 0
        }
    },

    activated() {
        LazzyLoad();
        this.$root.$emit('requestCurrentSong');
        this.$root.$on('currentSongPlaying', (songId, state) => {
            this.activeSongId = state != 'stopped' ? songId : 0;
        })
    },

    mounted() {
        $('#musicplayer').after( $("#"+ this.oid) );
        LazzyLoad();

        this.$root.$emit('requestCurrentSong');
        this.$root.$on('currentSongPlaying', (songId, state) => {
            this.activeSongId = state != 'stopped' ? songId : 0;
        })
    },

    methods: {
        play() {
            if (this.hasNoVideo) return;

            this.$parent.$emit('play-all', this.index);

            if (this.origin.split(".")[0] == 'search' || this.origin.split(".")[0] == 'playlist'){
                if (App.allowGtag) gtag('event', 'play_song', {
                    'event_category' : this.origin.split(".")[0],
                    'event_label' : `Play song from ${ this.origin.split(".")[1] }`
                });
            }else if (this.origin.split(".")[0] == 'mystuff'){
                if (App.allowGtag) gtag('event', 'play_song', {
                    'event_category' : this.origin.split(".")[0],
                    'event_label' : `Play own song from ${ this.origin.split(".")[1] }`
                });
            }else{
                if ( App.user.id != this.song.uploader_id ){
                    var verb = this.origin.split(".")[2] ? this.origin.split(".")[2] : "own";

                    if (App.allowGtag) gtag('event', 'play_song', {
                        'event_category' : this.origin.split(".")[0],
                        'event_label' : `Play ${ verb } song from ${ this.origin.split(".")[1] }`
                    });
                }
            }
        },

        openRoute() {
            if (this.origin.split(".")[0] == 'search'){
                if (App.allowGtag) gtag('event', 'open_song', {
                    'event_category' : this.origin.split(".")[1],
                    'event_label' : `Open song from ${ this.origin.split(".")[1] }`
                });
            }else if (this.origin.split(".")[0] == 'mystuff'){
                if (App.allowGtag) gtag('event', 'open_song', {
                    'event_category' : this.origin.split(".")[0],
                    'event_label' : `Open own song from ${ this.origin.split(".")[1] }`
                });
            }else{
                if ( App.user.id != this.song.uploader_id ){
                    var verb = this.origin.split(".")[2] ? this.origin.split(".")[2] : "own";
                    
                    if (App.allowGtag) gtag('event', 'open_song', {
                        'event_category' : this.origin.split(".")[1],
                        'event_label' : `Open ${ verb } song from ${ this.origin.split(".")[1] }`
                    });
                }
            }

            App.queryParams = this.song;
            this.$router.push({path: '/song/' + this.song.id});
        },

        showPlaylistManager(){
            this.showOptions = false;
            setTimeout(() => {
                this.$root.$emit('showPlaylistManager', this.song);    
            }, 350);            
        },        

        formatNumber(value){
            if (value > 1000000) return (value / 1000000).toFixed(1) +'M';
            if (value > 1000) return (value / 1000).toFixed(1) +'K';
            return Math.max(0, value);       
        },

        formatProcent(value){
            var evClass = value > 0 ? 'text-success' : (value == 0 ? '' : 'text-danger');
            return `<span class='${evClass}'>${ (value / 1).toFixed(1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") }%</span>`;
        },

        toggleLike(type) {
            var review = this.song.review;
            this.song.review = this.isLiked ? 'dislike' : 'like';

            this.$http.post(this.reviewEndpoint, { review: this.song.review }).then(() => {}, (error) => { this.song.review = review; });
        },

        toggleFollow() {
            var pick = this.song.artist_pick === 'followed' ? 'unfollow' : 'follow';
            this.updatePick(pick);
        },

        toggleBlock() {
            var pick = this.song.artist_pick === 'blocked' ? 'unblock' : 'block';
            this.updatePick(pick);
        },

        askDataPermission(){
            this.$http.post(this.getAccessEndpoint).then((success) => {
                if (App.allowGtag) gtag('event', `request_stats_access`, {
                    'event_category' : 'song',
                    'event_label' : `Request detailed stats for ${ this.isOwner ? 'own' : 'other user'} song`
                });

                this.requestPending = true;
            });

            this.showOptions = false;
        },        

        updatePick(pick) {
            this.$http.post(this.updatePickEndpoint, { pick: pick }).then((success) => {
                this.song.artist_pick = success.data.data.status;
                // this.$root.$emit('pickUpdated', this.song.artist_pick, this.song.uploader.id);
            });
        },

        togglePublish() {
            var verb = this.song.released ? 'delete' : 'post';
            this.$http[verb](this.publishEndpoint).then((success) => {
                this.song.released = !this.song.released;
            });            
        },

        toggleRelease() {
            var verb = this.song.public ? 'delete' : 'post';
            this.$http[verb](this.releaseEndpoint).then((success) => {
                this.song.public = !this.song.public;
            });            
        },

        shareMobile(){
            if (navigator.share) {
                navigator.share({
                    title: `${this.song.name} - ${this.song.artist}`,
                    text: `Check out this great song from ${this.song.uploader.name}`,
                    url: this.song.url
                }).then(() => console.log('Successful share'))
                .catch(error => console.log('Error sharing:', error));
            }else{
                alert('Navigator share disabled')
            }
        }        
    },

    computed: {
        getAccessEndpoint() {
            return App.restApi + '/api/song/'+ this.song.id +'/detailed-access';
        }, 

        reviewEndpoint() {
            return App.restApi + '/api/song/' + this.song.id + '/review';
        },

        updatePickEndpoint() {
            return App.restApi + '/api/user/' + this.song.uploader.id + '/picks';
        },

        publishEndpoint(){
            return App.restApi + '/api/v2/songs/' + this.song.id + '/released';
        },

        releaseEndpoint(){
            return App.restApi + '/api/v2/songs/' + this.song.id + '/public';
        },

        hasNoVideo(){
            return this.song.url == 'https://www.youtube.com/watch?v=soundfeed';
        },

        isLiked(){ return this.song.review == 'like'; },
        isDisliked(){ return this.song.review == 'dislike'; },
        isFollowed(){ return this.song.artist_pick === 'followed'; },
        isBlocked(){ return this.song.artist_pick === 'blocked'; },
        isPublished(){ return this.song.released; },
        isReleased(){ return this.song.public; },

        isArtist() { return this.song.uploader.type == 'artist'; },
        isLabel() { return this.song.uploader.type == 'label'; },        
        isOwner() { return App.user.id == this.song.uploader_id || App.user.id == 21; },
        hasDetailedAccess(){ return App.user.id == 21 || (this.song.flags && this.song.flags.users_with_detailed_access && this.song.flags.users_with_detailed_access.indexOf(App.user.id) > -1); },

        songPage() {
            return '/song/' + this.song.id;
        },

        views(){
            if (this.privacy && !this.isOwner && !this.hasDetailedAccess){
                return this.requestPending ?  'Request is pending' : 'Permission required';
            }

            if (!this.showData){
                var views = this.song.views && this.song.views.youtube ? this.formatNumber(this.song.views.youtube.count) : "NEW";
                return `<span class="text-dark">${views}</span>`;
            }

            // if (this.showData == 'performance'){ 
            //     var filter = this.filterValue.split(".")[1];
            //     var yday = this.song && this.song.performance && this.song.performance.youtube && this.song.performance.youtube[filter] ? this.formatNumber(this.song.performance.youtube[filter].financial) : false;
            //     var evolution = this.song && this.song.performance && this.song.performance.youtube && this.song.performance.youtube[filter] ? this.formatProcent(this.song.performance.youtube[filter].evolution) : false;

            //     return `<span class="text-dark">${yday}</span>` + (evolution ? `&nbsp;/&nbsp;<span class='${evClass}'>${evolution}</span>` : ``);
            // }

            if (this.showData == 'trending'){
                var media = this.filterValue.split(".")[0];
                var filter = this.filterValue.split(".")[1];

                if (this.filterKey == 'order_by_financial'){
                    var views = this.song && this.song.performance && this.song.performance[media] && this.song.performance[media][filter] ? this.formatNumber(this.song.performance[media][filter].financial) : false;
                    return `<span class="text-dark">${views}</span>`;
                }

                if (this.filterKey == 'order_by_evolution'){
                    var evolution = this.song && this.song.performance && this.song.performance[media] && this.song.performance[media][filter] ? this.formatProcent(this.song.performance[media][filter].evolution) : '?';
                    return `${evolution}`;
                }

                if (this.filterKey == 'order_by_provider_views'){
                    var evolution = this.song && this.song.views && this.song.views[media] ? this.formatNumber(this.song.views[media].count) : '?';
                    return `${evolution}`;
                }                
            }
        },

        getSongImage() {
            return `${App.restApi}/api/image/${this.song.picture_path}?width=128`;
        }
    },

    beforeDestroy(){
        $("#"+ this.oid).remove();
        this.$root.$off(['currentSongPlaying']);
    }    
}
</script>
